import { FC } from 'react';

import { LoadingLayout } from 'components';
import { useNavigate, usePageTitle } from 'libs/navigation';
import { ErrorFallback } from 'modules/App/ErrorFallback';
import { DirectoryProvider } from 'modules/directory/common/providers/DirectoryProvider';

import { useDirectoryRecord } from '../hooks/useDirectoryRecord';
import { useUpdateRecord } from '../hooks/useUpdateRecord';
import { DirectoryRecordView } from '../views/DirectoryRecordView';

export type DirectoryRecordContainerProps = {};

export const DirectoryRecordContainer: FC<
  DirectoryRecordContainerProps
> = () => {
  const { params } = useNavigate<{
    schemaId: string;
    directoryRecordId: string;
  }>();

  const {
    initialValues,
    validationSchema,
    fieldsConfig,
    loading,
    directoryName,
    currentRecord,
    currentSchema,
    notFound,
    onArchive,
    onDearchive,
  } = useDirectoryRecord(params.schemaId!, params.directoryRecordId!);

  const { isCanEdit, onSubmit, onDisableEdit, onEnableEdit, submitLoading } =
    useUpdateRecord({
      currentRecord,
      currentSchema,
    });

  usePageTitle(directoryName ?? '');

  if (notFound) {
    return <ErrorFallback />;
  }

  if (loading) {
    return <LoadingLayout />;
  }

  return (
    <DirectoryProvider
      record={currentRecord}
      onDisableEdit={onDisableEdit}
      onEnableEdit={onEnableEdit}
    >
      <DirectoryRecordView
        directoryName={directoryName}
        fieldsConfig={fieldsConfig}
        initialValues={initialValues}
        isArchived={!!currentRecord?.isArchived}
        isCanEdit={isCanEdit}
        submitLoading={submitLoading}
        validationSchema={validationSchema}
        onArchive={onArchive}
        onDearchive={onDearchive}
        onSubmit={onSubmit}
      />
    </DirectoryProvider>
  );
};
